import { Helmet, HelmetProps } from "react-helmet";

export const SEO = ({ children }: HelmetProps) => {
  return (
    <Helmet>
      <meta charSet="UTF-8" />
      <html lang="ja" />
      <title>ふわっち - ブランドサイト</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, viewport-fit=cover"
      />
      <meta
        name="description"
        content="ふわっちのブランド・ステートメント、ロゴマークの由来を紹介します"
      />

      <link rel="canonical" href="https://brand.whowatch.tv/" />

      <meta property="og:url" content="https://brand.whowatch.tv/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="ふわっち - ブランドサイト" />
      <meta property="og:site_name" content="ふわっち - ブランドサイト" />
      <meta
        property="og:description"
        content="ふわっちのブランド・ステートメント、ロゴマークの由来を紹介します"
      />
      <meta
        property="og:image"
        content="https://brand.whowatch.tv/ogp-image.png"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta property="twitter:site" content="@whowatch" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content="ふわっち - ブランドサイト" />
      <meta
        property="twitter:description"
        content="ふわっちのブランド・ステートメント、ロゴマークの由来を紹介します"
      />
      <meta
        name="twitter:image"
        content="https://brand.whowatch.tv/ogp-image.png"
      />

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap"
        rel="stylesheet"
      />

      {children}
    </Helmet>
  );
};
